import React, { useMemo, useState } from 'react';
import emailjs from '@emailjs/browser';

const useCaseOptions = [
  'RR.HH.',
  'Legal',
  'Comercial',
  'Atencion al cliente',
  'Otro',
];

const initialFormData = {
  fullName: '',
  email: '',
  phone: '',
  company: '',
  role: '',
  monthlyVolume: '',
  useCases: [],
  message: '',
  consent: false,
};

const ContactAreaOne = () => {
  const [formData, setFormData] = useState(initialFormData);
  const [submitState, setSubmitState] = useState({
    status: 'idle',
    message: '',
  });

  const emailConfig = useMemo(
    () => ({
      serviceId:
        process.env.REACT_APP_EMAILJS_SERVICE_ID || 'default_service',
      templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
      fromEmail:
        process.env.REACT_APP_CONTACT_FROM_EMAIL || 'contacto@firmascheck.cl',
      fromName:
        process.env.REACT_APP_CONTACT_FROM_NAME || 'FirmasCheck',
      toEmail:
        process.env.REACT_APP_CONTACT_TO_EMAIL || 'felipe@firmascheck.cl',
      ccEmail:
        process.env.REACT_APP_CONTACT_CC_EMAIL || 'ariel@firmascheck.cl',
    }),
    [],
  );

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;

    setFormData((currentData) => ({
      ...currentData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleUseCaseChange = (event) => {
    const { value, checked } = event.target;

    setFormData((currentData) => {
      const nextUseCases = checked
        ? [...currentData.useCases, value]
        : currentData.useCases.filter((item) => item !== value);

      return {
        ...currentData,
        useCases: nextUseCases,
      };
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!emailConfig.templateId || !emailConfig.publicKey) {
      setSubmitState({
        status: 'error',
        message:
          'El formulario aun no esta configurado para enviar correos. Revisa la configuracion de EmailJS y SendGrid.',
      });
      return;
    }

    setSubmitState({
      status: 'sending',
      message: '',
    });

    const templateParams = {
      title: `Nuevo contacto desde la landing - ${formData.fullName}`,
      name: formData.fullName,
      email: formData.email,
      time: new Date().toLocaleString('es-CL'),
      to_email: emailConfig.toEmail,
      cc_email: emailConfig.ccEmail,
      from_email_verified: emailConfig.fromEmail,
      from_name_verified: emailConfig.fromName,
      reply_to: formData.email,
      from_name: formData.fullName,
      from_email: formData.email,
      phone: formData.phone || 'No informado',
      company: formData.company,
      role: formData.role || 'No informado',
      monthly_volume: formData.monthlyVolume || 'No informado',
      use_cases:
        formData.useCases.length > 0
          ? formData.useCases.join(', ')
          : 'No informado',
      message: formData.message || 'Sin mensaje adicional',
      consent: formData.consent ? 'Si' : 'No',
      submitted_at: new Date().toLocaleString('es-CL'),
      form_details: [
        `Nombre: ${formData.fullName}`,
        `Email: ${formData.email}`,
        `Telefono: ${formData.phone || 'No informado'}`,
        `Empresa: ${formData.company}`,
        `Cargo: ${formData.role || 'No informado'}`,
        `Volumen mensual: ${formData.monthlyVolume || 'No informado'}`,
        `Casos de uso: ${
          formData.useCases.length > 0
            ? formData.useCases.join(', ')
            : 'No informado'
        }`,
        `Consentimiento: ${formData.consent ? 'Si' : 'No'}`,
        `Fecha de envio: ${new Date().toLocaleString('es-CL')}`,
        '',
        'Mensaje:',
        formData.message || 'Sin mensaje adicional',
      ].join('\n'),
    };

    try {
      await emailjs.send(
        emailConfig.serviceId,
        emailConfig.templateId,
        templateParams,
        emailConfig.publicKey,
      );

      setSubmitState({
        status: 'success',
        message: 'Gracias. Te contactaremos en menos de 1 dia habil.',
      });
      setFormData(initialFormData);
    } catch (error) {
      console.error('EmailJS send failed', error);
      setSubmitState({
        status: 'error',
        message:
          'No pudimos enviar tu mensaje. Intenta nuevamente o escribe a contacto@firmascheck.cl.',
      });
    }
  };

  return (
    <>
      {/* ========================= contact Area One start =========================*/}
      <div id="contacto" className="contact-area pd-top-100 pd-bottom-100">
        <div className="container">
          <div className="section-title text-center mb-5">
            <h6 className="sub-title">CONVERSEMOS</h6>
            <h2 className="title">
              ¿Listo para firmar mas rapido y con mas <span>control</span>?
            </h2>
            <p className="content">
              Cuentanos que documentos firmas hoy y te mostramos como reducir
              tiempos y errores.
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="single-input-inner style-border">
                      <input
                        type="text"
                        name="fullName"
                        placeholder="Nombre y apellido *"
                        value={formData.fullName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="single-input-inner style-border">
                      <input
                        type="email"
                        name="email"
                        placeholder="tu@empresa.com *"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="single-input-inner style-border">
                      <input
                        type="text"
                        name="phone"
                        placeholder="Telefono (opcional)"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="single-input-inner style-border">
                      <input
                        type="text"
                        name="company"
                        placeholder="Empresa *"
                        value={formData.company}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="single-input-inner style-border">
                      <input
                        type="text"
                        name="role"
                        placeholder="Cargo (opcional)"
                        value={formData.role}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="single-input-inner style-border">
                      <select
                        className="form-control"
                        name="monthlyVolume"
                        value={formData.monthlyVolume}
                        onChange={handleChange}
                      >
                        <option value="">Volumen mensual estimado</option>
                        <option value="1-20">1-20 documentos</option>
                        <option value="21-100">21-100 documentos</option>
                        <option value="101-500">101-500 documentos</option>
                        <option value="500+">500+ documentos</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="single-input-inner style-border">
                      <label className="mb-3 d-block">
                        Caso de uso principal:
                      </label>
                      <div className="checkbox-group d-flex flex-wrap gap-3">
                        {useCaseOptions.map((option) => (
                          <label
                            key={option}
                            className="checkbox-item d-flex align-items-center"
                          >
                            <input
                              type="checkbox"
                              value={option}
                              checked={formData.useCases.includes(option)}
                              onChange={handleUseCaseChange}
                              className="me-2"
                              style={{ width: 'auto', height: 'auto' }}
                            />
                            <span className="badge bg-light text-dark px-3 py-2">
                              {option}
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="single-input-inner style-border">
                      <textarea
                        name="message"
                        placeholder="Necesitamos firmar contratos laborales de manera remota..."
                        rows="4"
                        value={formData.message}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="single-input-inner">
                      <label className="checkbox-label d-flex align-items-start">
                        <input
                          type="checkbox"
                          name="consent"
                          checked={formData.consent}
                          onChange={handleChange}
                          required
                          className="me-2 mt-1"
                          style={{
                            width: 'auto',
                            height: 'auto',
                            minWidth: '16px',
                          }}
                        />
                        <span className="text-sm">
                          Autorizo a FirmasCheck a contactarme y enviar
                          informacion relacionada. *
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn btn-base w-100 border-radius-5"
                      disabled={submitState.status === 'sending'}
                    >
                      {submitState.status === 'sending'
                        ? 'Enviando...'
                        : 'Enviar'}
                    </button>
                  </div>
                </div>
              </form>

              <div className="mt-4 text-center">
                {submitState.status === 'success' ? (
                  <div
                    className="success-message"
                    style={{ color: 'green' }}
                  >
                    {submitState.message}
                  </div>
                ) : null}
                {submitState.status === 'error' ? (
                  <div className="error-message" style={{ color: 'red' }}>
                    {submitState.message}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*========================= contact-inner One end =========================*/}
    </>
  );
};

export default ContactAreaOne;
